import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../../client-config/index';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    private readonly environment = inject(EnvironmentConfig).configuration;
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (
            req.url.indexOf(this.environment.SITESERVER_ENDPOINT || '') !== -1 ||
            req.url.indexOf(this.environment.SITESERVER_COMMENTARY_ENDPOINT || '') !== -1
        ) {
            const secureReq = req.clone({
                url:
                    req.url.indexOf('?') !== -1
                        ? `${req.url}&translationLang=en&responseFormat=json`
                        : `${req.url}?translationLang=en&responseFormat=json`,
            });
            return next.handle(secureReq);
        }
        return next.handle(req);
    }
}
